export default __webpack_public_path__ + "8a410660f12ad3fc6018ccbdfe22b255.svg";